import jQuery from 'jquery';

jQuery((
  $: JQueryStatic
) => {
  $('form')
    .on('submit', (
      event
    ) => {
      event.preventDefault();

      const form = $(event.currentTarget);
      const body = form.serialize();
      const fieldset = form
        .children('fieldset')
        .attr('disabled', 'disabled');
      const action = form.attr('action') ?? '/';
      fetch(action, {
        method: form.attr('method') ?? 'GET',
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        },
        body
      })
        .then((
          res
        ) => res.status === 201 ? '.pass' : Promise.reject(res))
        .catch(() => '.fail')
        .then((selector) => {
          fieldset
            .removeAttr('disabled');
          form
            .find('p')
            .css('display', 'none');
          form
            .find(selector)
            .css('display', 'block')
            .get(0)
            ?.scrollIntoView({
              block: 'center',
              inline: 'center',
              behavior: 'smooth'
            });
        })
        .catch((
          error: unknown
        ) => {
          console.error(error);
        });
    });
});
